module.exports = __webpack_public_path__ + "static/media/is_beach.5ccfa9fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/is_beach.svg
// module id = 1427
// module chunks = 0